<template>
  <of-dialog :title="formTitle" @onCancel="cancel" :appendToBody="true">
    <div slot="content">
      <el-form label-width="120px" :model="dataForm">
        <el-form-item label="标题：" prop="Title">
          {{ dataForm.Title }}
        </el-form-item>
        <el-form-item label="支出描述：" prop="Describe">
          {{ dataForm.Describe }}
        </el-form-item>
        <el-form-item label="支出金额：" prop="Amount">
          {{ dataForm.Amount }}
        </el-form-item>
        <el-form-item label="支出时间:" prop="ExpendTime">
          {{ (dataForm.ExpendTime * 1000) | formatDate }}
        </el-form-item>
        <el-form-item label="附件:" prop="File">
          <of-upload
            class="upload-demo"
            list-type="fileList"
            @onPreview="onFilePreview"
            :limit="1"
            :fileList="fileList"
            :class="{ hideFile: true }"
          >
          </of-upload>
        </el-form-item>
      </el-form>
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import OfUpload from "@/components/controls/of_upload/of_upload";
import { saveAs } from "file-saver";
import api from "@/modules/zjrc/api";

export default {
  name: "edit",
  props: {
    dataForm: Object,
    default: null,
  },
  components: {
    OfDialog,
    OfUpload,
  },
  data() {
    return {
      formTitle: "查看详情",
      fileList:[],//附件数组
    };
  },
  mounted(){
    let that=this;
    that.getlistfile();
  },
  methods: {
    //附件下载
    onFilePreview(file){
      saveAs(file.url, file.name);
    },
    //加载文件
    getlistfile() {
      let that = this;
      if (that.dataForm.File === undefined || that.dataForm.File === null) {
        return;
      }
      let params = { Id: that.dataForm.File };
      api.QueryBigSickApplyFileByIds(params).then((res) => {
        if (res.data.Code == 0) {
          let fileList = res.data.Data;
          fileList.forEach((item) => {
            that.fileList.push({url:item.Url,name:item.FileName});
          });
        }
      });
    },
    //取消
    cancel() {
      this.$emit("formCallBack", null);
    },
  },
};
</script>
<style scoped>
.of-dialog >>> .el-button--primary {
  display: none;
}

.of-dialog >>> .el-button--default {
  display: none;
}

.hideFile >>> .el-icon-close {
  display: none !important;
}
.hideFile >>> .el-icon-close-tip {
  display: none !important;
}
</style>